import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IColum } from "../../../../../utils/copyToClipboardInXlsFormat";
import { IntlFormatUSD } from "../../../../../utils";
import { ComplianceAPI } from "../../../../../api/compliance";
import { SearchByListValues } from "../../../../../components/ui";
import { CENTS_IN_DOLLAR } from "../../../../../constants";
import { complianceSearchActions } from "../../../../../reducers/complianceSearch";
import { getQueryStringByStringValues } from "../../../utils";
import { EMAILS_LIST_VALIDATION_SCHEMA } from "../../../../../utils/validation";
import { useComplianceSearchContext } from "../../../../../context";
import { CopyToClipboard, Table } from "../../../../../components/ui";
import { SectionTitle } from "../../../styledComponents";

const COLUMNS: Array<IColum> = [
  {
    by: "id",
    title: "Account ID",
    path: "id",
  },
  {
    by: "total_spent",
    title: "Total spent",
    path: "total_spent",
    copyToClipBoardCallBack: (value) => IntlFormatUSD(+value / CENTS_IN_DOLLAR),
    getCellValue: (value) => IntlFormatUSD(+value / CENTS_IN_DOLLAR),
  },
  {
    by: "name",
    title: "Name",
    path: "name",
    getCellValue: (value) => <CopyToClipboard value={value as unknown as string} />,
  },
  {
    by: "email",
    title: "Email",
    path: "email",
    getCellValue: (value) => <CopyToClipboard value={value as unknown as string} />,
  },
  {
    by: "reg_ip",
    title: "Reg IP",
    path: "reg_ip",
  },
  {
    by: "phone",
    title: "Phone",
    path: "phone",
  },
  {
    by: "address",
    title: "Address",
    path: "address",
  },
  {
    by: "address2",
    title: "Address 2",
    path: "address2",
  },
  {
    by: "city",
    title: "City",
    path: "city",
  },
  {
    by: "stateprov",
    title: "Stateprov",
    path: "stateprov",
  },
  {
    by: "country",
    title: "Country",
    path: "country",
  },
  {
    by: "joined",
    title: "Joined",
    path: "joined",
  },
];

const BasicAccountDetailsAndSalesValue = (): React.ReactElement => {
  const dispatch = useDispatch();

  const { tabsTablesSearchState, setTabsTablesSearchState } = useComplianceSearchContext();
  const { emails } = tabsTablesSearchState.quickSearchTab.basicAccountDetailsAndSalesValue.search;

  const { loading, data } = useSelector(
    (state) => state.complianceSearch.basicAccountDetailsAndSalesValue
  );

  const fetchData = async (values: { emails: string }) => {
    setTabsTablesSearchState({
      ...tabsTablesSearchState,
      quickSearchTab: {
        ...tabsTablesSearchState.quickSearchTab,
        basicAccountDetailsAndSalesValue: {
          search: { emails: values.emails },
        },
      },
    });

    try {
      dispatch(complianceSearchActions.fetchBasicAccountDetailsAndSalesValueRequest());
      const response = await ComplianceAPI.getBasicAccountDetailsAndSalesValue(
        getQueryStringByStringValues("emails", values.emails)
      );
      dispatch(
        complianceSearchActions.fetchBasicAccountDetailsAndSalesValueSuccess(response.data.accounts)
      );
    } catch (error) {
      dispatch(complianceSearchActions.fetchBasicAccountDetailsAndSalesValueFailed());
      console.log("Error fetching basic account details and sales value data", error);
    }
  };

  return (
    <SectionTitle title="Basic Account Details And Sales Value">
      <SearchByListValues
        placeholder="john@gmail.com, doe@gmail.com e.t.c ..."
        label="Emails"
        name="emails"
        validationSchema={EMAILS_LIST_VALIDATION_SCHEMA}
        isLoading={loading}
        fetchData={fetchData}
        initialValues={{ emails }}
      />

      <Table
        loading={loading}
        columns={COLUMNS}
        extractKey={(row) => row.id}
        data={data}
        csv_table_name="E2T quick search - Basic Account Details And Sales Value"
      />
    </SectionTitle>
  );
};

export default BasicAccountDetailsAndSalesValue;
